import { getOrganizationById, getOrganizations } from '@/services';
import { useQuery } from '@tanstack/react-query';

export const useOrganization = (organizationId: string) => {
  const { data: organizationData } = useQuery({
    queryKey: ['organization', organizationId],
    queryFn: async () => getOrganizationById(organizationId, true),
    enabled: !!organizationId,
  });
  return { organizationData };
};

export const useOrganizations = (enabled: boolean) => {
  return useQuery({
    queryKey: ['organizations'],
    queryFn: async () => {
      const response = await getOrganizations();
      return response;
    },
    enabled,
  });
};
